import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import {
  openConfirmTalentToggle,
  openTalentForm,
  openTalentView,
} from "../../store/reducers/plantels/talentsByPlantels.reducer";
import { getTalentByplantelByIdThunk } from "../../store/reducers/plantels/plantels.thunks";

const TalentoRow = ({ talento }) => {
  const dispatch = useDispatch();

  const handleView = () => {
    dispatch(openTalentView());
    dispatch(getTalentByplantelByIdThunk(talento.id));
  };
  const handleEdit = async () => {
    await dispatch(getTalentByplantelByIdThunk(talento.id));
    dispatch(openTalentForm({ mode: "edit" }));
  };

  const handleToggle = () => {
    dispatch(openConfirmTalentToggle({ id: talento.id }));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";
  return (
    <tr>
      <td>{talento.nombre}</td>
      <td>{talento.plantel_nombre}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill ${
            talento.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {talento.is_active ? "Activo" : "Inactivo"}
        </span>
      </td>

      <td>
        <button
          type="button"
          className="btn btn-sm"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <Icon
            icon="ph:dots-three-outline-vertical-fill"
            width="20"
            className="text-neutral-700"
          />
        </button>
        <ul className="dropdown-menu p-12 border bg-base shadow">
          <li>
            <button className={itemClass} onClick={handleView}>
              <Icon icon="mdi:eye-outline" width="18" />
              <span>Ver</span>
            </button>
          </li>

          <li>
            <button className={itemClass} onClick={handleEdit}>
              <Icon icon="mdi:pencil-outline" width="18" />
              <span>Editar</span>
            </button>
          </li>

          <li>
            <button
              className={`${itemClass} ${talento.is_active ? "text-danger" : "text-success"}`}
              onClick={handleToggle}
            >
              <Icon
                icon={
                  talento.is_active
                    ? "mdi:toggle-switch-off-outline"
                    : "mdi:toggle-switch-outline"
                }
                width="18"
              />
              <span>{talento.is_active ? "Desactivar" : "Activar"}</span>
            </button>
          </li>
          <li></li>
        </ul>
      </td>
    </tr>
  );
};

export default TalentoRow;
